import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  GO_TO_PREVIOUS_BUTTON: `${cleanedFilename(__filename)}-go-to-previous-button`,
  GO_TO_NEXT_BUTTON: `${cleanedFilename(__filename)}-go-to-next-button`,
};
